import RewardsIcon from './RewardsIcon'

export default RewardsIcon
